import { Component, HostBinding, Input } from '@angular/core';

import {
  RlaGuards,
  RouteLinkAction,
} from '../../../../types/route-link-action';

@Component({
    selector: 'lui-footer-basic',
    templateUrl: './footer-basic.component.html',
    standalone: false
})
export class FooterBasicComponent {
  @HostBinding('class') className = 'footer-basic';

  @Input() links!: RouteLinkAction[] | null | undefined;
  @Input() copyright!: string;

  date = new Date();

  isRoute = RlaGuards.isRoute;

  isLink = RlaGuards.isLink;

  isAction = RlaGuards.isAction;
}
